import { useEffect, useState } from "react";
import { apiSession, type Outlet } from "./api";

type Session = {
  loggedIn: boolean;
  user?: { firstName?: string; lastName?: string };
  outlets?: Outlet[];
  activeOutletId?: string;
  market?: string;
};

const KEY_OUTLET = "nomni:activeOutletId";

export function useSession() {
  const [s, setS] = useState<Session>({ loggedIn: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await apiSession();
        if (cancelled) return;
        const active = localStorage.getItem(KEY_OUTLET) ?? r.outlets?.[0]?.outletId;
        setS({
          loggedIn: r.ok,
          user: r.user,
          outlets: r.outlets,
          activeOutletId: active ?? undefined,
          market: r.market,
        });
      } catch {
        if (!cancelled) setS({ loggedIn: false });
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  function setActiveOutlet(outletId: string) {
    localStorage.setItem(KEY_OUTLET, outletId);
    setS((p) => ({ ...p, activeOutletId: outletId }));
  }

  return { session: s, loading, setActiveOutlet };
}
